import { message } from './index';

export interface Button {
  title: string;
  type?: string;
  payload?: string;
  data_options?: string;
  webview_height_ratio?: string;
  url?:  string;
  sku?: string;
  action?: string;
}
export interface ICard {
  title?: string;
  image_url?: string;
  details?: string;
  buttons?: Button[];
  text?: string;
  quick_replies?: QuickReply[];
  webviewUrl?: string;
  video_url?: string;
  subtitle?: string
}
export interface QuickReply {
  content_type?: string;
  title?: string;
  payload?: string;
  image_url?: string;
}
export class Card {
  
  constructor() {}

  getUrl(button: Button) {
      if (button && button.webview_height_ratio === "tall") {
          return button.url + "?#";
      }
      return button.url;
  }
  applyLargeStyles(card: ICard){
      if (card && !card.subtitle && card.buttons.length==1){
          return true;
      }
      else {
          return false;
      }
  }
  showMoreText(desc: string, numberOfChars: number) {
      if (desc.length > numberOfChars) {
          let shortOne = desc.substring(0, numberOfChars);
          return shortOne + "...";
      } else {
          return desc;
      }
  }
  // isShowMoreCard(title: string) {
  //     if (title == "عرض المزيد" || title == "Show More") return true;
  //     return false;
  // }
  // formatCards(cards: ICard[]) {
  //     if (this.isShowMoreCard(cards[cards.length - 1].title)) {
  //         return cards.splice(cards.length - 1);
  //     } else {
  //         return cards;
  //     }
  // }
  trauncateTitle(card: ICard) {
      let formatedTitle = message.cleanText(card.title);
      // if (card && card.buttons.length > 1 && formatedTitle.length > 20) {
      //   let shortOne = formatedTitle.substring(0, 20);
      //   return shortOne + "...";
      // } else 
      if (card && formatedTitle.length > 50) {
        let shortOne = formatedTitle.substring(0, 50);
        return shortOne + "...";
      } else {
        return formatedTitle;
      }
  }
  // getProductLink(buttons: Button[]) {
  //     for (let i = 0; i < buttons.length; i++) {
  //       if (
  //         buttons[i].type == "web_url" &&
  //         buttons[i].webview_height_ratio == "full"
  //       ) {
  //         return buttons[i].url;
  //       }
  //     }
  //   }
  // checkPrice(title: string) {
  //   let regex = new RegExp("[0-9]+");
  //   let prices: any = [];
  //   if (regex.test(title) == true) {
  //     prices = title.match(/\d+(?:\.\d+)?/g);
  //     return prices;
  //   } else {
  //     return prices;
  //   }
  // }
}